// ------------BurgerMenuModule------------
const BurgerMenuModule = {
  init() {
    const burgerMenu = document.getElementById('burgerMenu');
    const headerMenu = document.getElementById('headerMenu');
    const overlay = document.getElementById('drawerOverlay');

    if (!burgerMenu || !headerMenu) return;

    // Открытие/закрытие по бургеру
    burgerMenu.addEventListener('click', function () {
      burgerMenu.classList.toggle('burger__active');
      headerMenu.classList.toggle('burger__active');
      if (overlay) overlay.classList.toggle('burger__active');

      const isExpanded = burgerMenu.classList.contains('burger__active');
      burgerMenu.setAttribute('aria-expanded', isExpanded);

      // Блокируем скролл страницы когда меню открыто
      document.body.style.overflow = isExpanded ? 'hidden' : '';
    });

    // Закрытие по клику на пункт меню
    const menuLinks = document.querySelectorAll('.drawer__link');
    menuLinks.forEach(link => {
      link.addEventListener('click', function () {
        BurgerMenuModule.close();
      });
    });

    // Закрытие по клику на оверлей
    if (overlay) {
      overlay.addEventListener('click', function () {
        BurgerMenuModule.close();
      });
    }
  },

  close() {
    const burgerMenu = document.getElementById('burgerMenu');
    const headerMenu = document.getElementById('headerMenu');
    const overlay = document.getElementById('drawerOverlay');

    if (burgerMenu) burgerMenu.classList.remove('burger__active');
    if (headerMenu) headerMenu.classList.remove('burger__active');
    if (overlay) overlay.classList.remove('burger__active');
    if (burgerMenu) burgerMenu.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
};
// ------------END------------

// ------------SliderModule (Vanilla JS: Splide + GLightbox) ------------
const SliderModule = {
  init() {
    // 1. Инициализация Слайдера (замена Slick)
    const sliderElement = document.querySelector('.splide'); // В HTML нужно добавить класс splide и обертку
    if (sliderElement) {
      new Splide('.splide', {
        type: 'loop',         // Бесконечный цикл
        focus: 'center',       // Аналог centerMode
        autoWidth: true,       // Аналог variableWidth
        gap: '20px',           // Расстояние между слайдами
        autoplay: true,
        interval: 3000,
        arrows: false,
        pagination: false,
        perPage: 3,
        breakpoints: {
          768: {
            perPage: 3,
            gap: '10px',
          },
          480: {
            perPage: 1,
            gap: '5px',
            focus: 'center',
          },
        },
      }).mount();
    }

    // 2. Инициализация Лайтбокса (замена Lightbox2)
    // Больше не нужно настраивать опции отдельно, все делается одной строкой
    if (typeof GLightbox !== 'undefined') {
      const lightbox = GLightbox({
        selector: '.glightbox',
        loop: true,                 // ВКЛЮЧАЕТ ПРОЛИСТЫВАНИЕ ПО КРУГУ
        touchNavigation: true,      // Свайпы на мобильных
        touchFollowMouse: true,     // Картинка "идет" за пальцем
        dragNavigation: true,       // Листание мышкой на десктопе
        keyboardNavigation: true,   // Стрелочки на клавиатуре
        openEffect: 'zoom',
        closeEffect: 'zoom'
      });
    }
  }
};
// ------------END ------------

// ------------ProductModule: Подсчет общей суммы для каждого товара-----
const ProductModule = {
  init() {
    document.querySelectorAll('.products__card-section').forEach(section => {
      this.initializeProduct(section);
      this.updateTotalAmount(section);
    });
  },

  updateTotalAmount(section) {
    let totalAmount = 0;
    const productOrders = section.querySelectorAll('.products__card-order');

    productOrders.forEach(order => {
      const priceElement = order.querySelector('.product__price');
      const quantityElement = order.querySelector('.products__card-number');

      if (priceElement && quantityElement) {
        // --- ИЗМЕНЕНИЕ ЗДЕСЬ ---
        // Очищаем строку от пробелов и используем parseFloat
        const price = parseFloat(priceElement.textContent.trim());
        const quantity = Number(quantityElement.textContent); // Number() здесь работает нормально для целых чисел

        // Проверяем, что цена и количество являются числами
        if (!isNaN(price) && !isNaN(quantity)) {
          totalAmount += price * quantity;
        }
      }
    });

    // Выводим посчитанную сумму на экран
    const totalAmountElement = section.querySelector('.products__total-amount');
    if (totalAmountElement) {
      totalAmountElement.textContent = totalAmount;
    }
  },

  initializeProduct(section) {
    const productOrders = section.querySelectorAll('.products__card-order');

    productOrders.forEach(order => {
      const plusBtn = order.querySelector('.products__card-btn--plus');
      const minusBtn = order.querySelector('.products__card-btn--minus');
      const numberDisplay = order.querySelector('.products__card-number');

      if (plusBtn && minusBtn && numberDisplay) {
        plusBtn.addEventListener('click', () => {
          let currentQuantity = Number(numberDisplay.textContent);
          currentQuantity += 1;
          numberDisplay.textContent = currentQuantity;
          this.updateTotalAmount(section);
        });

        minusBtn.addEventListener('click', () => {
          let currentQuantity = Number(numberDisplay.textContent);
          if (currentQuantity > 0) {
            currentQuantity -= 1;
            numberDisplay.textContent = currentQuantity;
            this.updateTotalAmount(section);
          }
        });
      }
    });
  }
};
// ------------END------------

// ------------PhoneModule (управление телефоном на checkout)------------
const PhoneModule = {
  init() {
    const phoneInput = document.getElementById('phone');

    // Проверяем, существует ли элемент
    if (!phoneInput) return;

    // Устанавливаем начальное значение
    if (!phoneInput.value) {
      phoneInput.value = '+48 ';
    }

    phoneInput.addEventListener('input', function (e) {
      let value = e.target.value;

      // 1. Запрещаем удалять +48
      if (!value.startsWith('+48')) {
        value = '+48';
      }

      // 2. Удаляем все символы кроме цифр и +
      value = value.replace(/[^\d+]/g, '');

      // 3. Ограничиваем длину (+48 и 9 цифр = 12 символов)
      if (value.length > 12) {
        value = value.slice(0, 12);
      }

      // 4. Форматируем номер (+48 XXX XXX XXX)
      if (value.length > 3) {
        let formatted = value.match(/(\+\d{2})(\d{0,3})(\d{0,3})(\d{0,3})/);
        if (formatted) {
          value = formatted[1] +
            (formatted[2] ? ' ' + formatted[2] : '') +
            (formatted[3] ? ' ' + formatted[3] : '') +
            (formatted[4] ? ' ' + formatted[4] : '');
        }
      }

      this.value = value;
    });

    // 5. Запрещаем удаление +48 при удалении или вырезании
    phoneInput.addEventListener('keydown', function (e) {
      if (e.key === 'Backspace' || e.key === 'Delete') {
        // Защищаем первые 3 символа (+48)
        if (this.value.trim().length <= 3) {
          e.preventDefault();
        }
      }
    });
  }
};
// ------------END------------

// ------------CartModule - корзина------------
const CartModule = {
  // Главный инициализатор
  init() {
    this.updateCartCounter();
    this.initProductPage();
    this.initCheckoutPage();
    this.initPaymentMethodListener();
  },

  // Логика кнопки "В корзину"
  initProductPage() {
    const addToCartButton = document.querySelector('.products__card-btn--order');
    if (!addToCartButton) return;

    addToCartButton.addEventListener('click', (e) => {
      // 1. Проверяем сумму
      const totalAmountElement = document.querySelector('.products__total-amount');
      const totalAmount = parseFloat(totalAmountElement.textContent);

      // 2. ЕСЛИ СУММА 0 — ЗАПУСКАЕМ АНИМАЦИЮ
      if (totalAmount === 0) {
        // ИСПОЛЬЗУЕМ CartModule ВМЕСТО this ДЛЯ НАДЕЖНОСТИ
        CartModule.triggerZeroAmountAnimation(addToCartButton, totalAmountElement);
        return;
      }

      // 3. Если сумма > 0, сохраняем (также через CartModule для надежности)
      CartModule.saveToCart();
    });
  },

  // --- ФУНКЦИЯ: Анимация ошибки ---
  triggerZeroAmountAnimation(button, amountElement) {

    // 2. Красим кнопку и меняем текст
    button.classList.add('btn-error');
    const span = button.querySelector('span');
    const originalText = span.textContent;

    // Текст ошибки (можно оставить хардкод или брать из ui.json)
    span.textContent = 'Wybierz produkt!';

    // 3. Красим цифру 0
    amountElement.classList.add('amount-error');

    // 4. Через 2 секунды сбрасываем всё назад
    setTimeout(() => {
      button.classList.remove('shake-animation');
      button.classList.remove('btn-error');
      span.textContent = originalText;
      amountElement.classList.remove('amount-error');
    }, 2000);
  },

  // Страница корзины (Checkout)
  initCheckoutPage() {
    const productsList = document.querySelector('.selected-products__list');
    if (!productsList) return;

    this.displayCartItems();
    this.initRemoveButtons();
  },

  // Слушатель изменения способа оплаты
  initPaymentMethodListener() {
    const paymentRadios = document.querySelectorAll('input[name="payment_method"]');
    const depositBlock = document.getElementById('dynamic-deposit-amount');
    const depositValueDisplay = document.getElementById('deposit-value-display');
    const totalAmountElement = document.querySelector('.selected-products__total-amount');

    if (!paymentRadios.length || !depositBlock) return;

    // Функция пересчета
    const updateDepositDisplay = () => {
      const selectedMethod = document.querySelector('input[name="payment_method"]:checked').value;
      
      if (selectedMethod === 'cash_pickup') {
        // Берем общую сумму и считаем 30%
        const total = parseFloat(totalAmountElement.textContent) || 0;
        const deposit = (total * 0.3).toFixed(2); // Округляем до копеек
        
        depositValueDisplay.textContent = deposit;
        depositBlock.style.display = 'block'; // Показываем блок
      } else {
        depositBlock.style.display = 'none'; // Прячем для остальных методов
      }
    };

    // Вешаем слушатель на все радио-кнопки
    paymentRadios.forEach(radio => {
      radio.addEventListener('change', updateDepositDisplay);
    });

    // Вызываем один раз при загрузке, чтобы проверить, что выбрано по умолчанию
    updateDepositDisplay();
  },

  // Обновление счетчика в шапке
  updateCartCounter() {
    const cartItems = JSON.parse(localStorage.getItem('cart')) || [];
    const counter = document.querySelector('.header__cart-amount');
    if (counter) {
      const totalItems = cartItems.reduce((sum, item) => sum + item.quantity, 0);
      counter.textContent = totalItems;
    }
  },

  // Сохранение в корзину
  saveToCart() {
    const productOrders = document.querySelectorAll('.products__card-order');
    let cartItems = JSON.parse(localStorage.getItem('cart')) || [];

    let itemsForAnalytics = [];
    let totalValueAdded = 0;
    let addedAnyProduct = false; // Флаг: добавил ли клиент хоть что-то
    const productName = document.querySelector('h1.product-page__title')?.innerText.trim() || 'Produkt';

    // 1. Обрабатываем все товары и допы
    productOrders.forEach(order => {
      const volumeElement = order.querySelector('.product__packaging');
      const priceElement = order.querySelector('.product__price');
      const quantityElement = order.querySelector('.products__card-number');

      if (volumeElement && priceElement && quantityElement) {
        const quantity = parseInt(quantityElement.textContent);
        const cleanSku = order.dataset.sku || 'no-sku';
        const cleanName = order.dataset.name || productName;
        const price = parseFloat(priceElement.textContent.trim());
        const volume = volumeElement.textContent.trim();

        if (quantity > 0) {
          addedAnyProduct = true;
          const itemTotal = quantity * price;

          itemsForAnalytics.push({
            item_id: cleanSku,
            item_name: cleanName,
            price: price,
            quantity: quantity
          });
          totalValueAdded += itemTotal;

          const existingItemIndex = cartItems.findIndex(item => item.sku === cleanSku && item.volume === volume);

          if (existingItemIndex !== -1) {
            cartItems[existingItemIndex].quantity += quantity;
            cartItems[existingItemIndex].total += itemTotal;
          } else {
            cartItems.push({
              sku: cleanSku,
              title: cleanName,
              volume: volume,
              price: price,
              quantity: quantity,
              total: itemTotal
            });
          }
        }
      }
    });

    // 2. БЛОК ЦВЕТОВ: Добавляем их как самостоятельные строки (только если добавили товар)
    if (addedAnyProduct) {
      const attributeSelects = document.querySelectorAll('.products__attribute-select');

      attributeSelects.forEach(select => {
        const attrName = select.getAttribute('data-attr-name');
        const attrValue = select.value;
        const volumeText = `${attrName}: ${attrValue}`;

        // Создаем для цвета свой технический SKU
        const attrSku = `attr-${attrName.replace(/[^a-zA-Z0-9]/g, '')}`;

        const existingAttrIndex = cartItems.findIndex(item => item.sku === attrSku);

        if (existingAttrIndex !== -1) {
          // Если цвет уже был, просто обновляем его значение
          cartItems[existingAttrIndex].volume = volumeText;
        } else {
          // Иначе добавляем как новую строчку в корзину
          cartItems.push({
            sku: attrSku,
            title: productName,
            volume: volumeText,
            price: 0,
            quantity: 1,
            total: 0
          });
        }
      });
    }

    if (itemsForAnalytics.length > 0) {
      AnalyticsModule.sendAddToCartData(itemsForAnalytics, totalValueAdded);
    }

    localStorage.setItem('cart', JSON.stringify(cartItems));
    this.updateCartCounter();
  },

  // Удаление счетчиков (если нужно)
  resetProductCounters() {
    const productOrders = document.querySelectorAll('.products__card-order');
    productOrders.forEach(order => {
      const quantityElement = order.querySelector('.products__card-number');
      if (quantityElement) quantityElement.textContent = '0';
    });
    const totalAmountElement = document.querySelector('.products__total-amount');
    if (totalAmountElement) totalAmountElement.textContent = '0';
  },

  // Удаление товара (кнопка в корзине)
  initRemoveButtons() {
    const productsList = document.querySelector('.selected-products__list');
    if (productsList) {
      productsList.addEventListener('click', (event) => {
        if (event.target.classList.contains('selected-products__item-remove')) {
          const index = event.target.getAttribute('data-index');
          this.removeFromCart(index);
        }
      });
    }
  },

  removeFromCart(index) {
    let cartItems = JSON.parse(localStorage.getItem('cart')) || [];
    if (index >= 0 && index < cartItems.length) {
      cartItems.splice(index, 1);
      localStorage.setItem('cart', JSON.stringify(cartItems));
      this.updateCartCounter();
      this.displayCartItems();
    }
  },

  // Отображение товаров в корзине
  displayCartItems() {
    setTimeout(() => {
      const cartItems = JSON.parse(localStorage.getItem('cart')) || [];
      const productsList = document.querySelector('.selected-products__list');
      let totalSum = 0;

      if (!productsList) return;
      productsList.innerHTML = '';

      if (cartItems.length > 0) {
        cartItems.forEach((item, index) => {
          const productElement = document.createElement('div');
          productElement.className = 'selected-products__item';

          // Рендерим абсолютно одинаково и товары, и цвета
          productElement.innerHTML = `
          <div class="selected-products__item-info">
            <span class="selected-products__item-name">${item.title}</span>
            <span class="selected-products__item-volume">${item.volume}</span>
          </div>
          <div class="selected-products__item-numbers">
            <span class="selected-products__item-quantity">Ilość: ${item.quantity}</span>
            <span class="selected-products__item-price">${item.total} zł</span>
            <button class="selected-products__item-remove" data-index="${index}">Usuń</button>
          </div>
          `;
          productsList.appendChild(productElement);
          totalSum += item.total;
        });
      }

      const totalAmountElement = document.querySelector('.selected-products__total-amount');
      if (totalAmountElement) {
        totalAmountElement.textContent = totalSum;
      }
    }, 100);
  },
};
// ------------END------------

// ------------Обработка формы и отправка в Telegram------------
const FormModule = {

  // Флаг блокировки повторной отправки
  isSubmitting: false,

  init() {
    const form = document.getElementById('checkout-form');

    // ПРОВЕРКА: Вешаем слушатель только если его еще нет
    if (form && !form.dataset.initialized) {
      form.addEventListener('submit', this.handleFormSubmit.bind(this));
      form.dataset.initialized = 'true';
    }
  },

  async handleFormSubmit(e) {
    e.preventDefault();

    // ЗАМОК: Если форма уже отправляется — игнорируем нажатия
    if (this.isSubmitting) return;
    this.isSubmitting = true;

    const form = e.target;
    const submitButton = form.querySelector('button[type="submit"]');

    // Визуально блокируем кнопку
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.style.opacity = '0.5';
      submitButton.innerText = 'Wysyłanie...'; // Польский
    }

    // Получаем корзину
    const cartItems = JSON.parse(localStorage.getItem('cart')) || [];

    if (cartItems.length === 0) {
      alert('Proszę dodać produkty do koszyka!'); // Польский
      this.isSubmitting = false;
      if (submitButton) { submitButton.disabled = false; submitButton.style.opacity = '1'; submitButton.innerText = 'Zamawiam'; }
      return;
    }

    // --- ПРОВЕРКА НОМЕРА (Польша: 48 + 9 цифр = 11) ---
    const phoneInput = form.querySelector('#phone');
    const phoneNumber = phoneInput.value;
    const digitsOnly = phoneNumber.replace(/[^\d]/g, '');

    if (digitsOnly.length !== 11) {
      alert(window.uiText?.alerts?.invalidPhone || 'Wprowadź prawidłowy numer telefonu (9 cyfr)');
      phoneInput.style.border = '2px solid red';
      setTimeout(() => { phoneInput.style.border = ''; }, 3000);

      this.isSubmitting = false;
      if (submitButton) { submitButton.disabled = false; submitButton.style.opacity = '1'; submitButton.innerText = 'Zamawiam'; }
      return;
    }

    // --- ПРОВЕРКА СОГЛАСИЯ С ПРАВИЛАМИ (Regulamin) ---
    const termsCheckbox = form.querySelector('#accept_terms');
    if (termsCheckbox && !termsCheckbox.checked) {
      // Выводим системное сообщение
      alert('Proszę zaakceptować Regulamin sklepu, aby kontynuować.');

      // Визуально подсвечиваем текст красным на 3 секунды, чтобы клиент понял, где ошибка
      const termsText = form.querySelector('.checkout__checkbox-text');
      if (termsText) {
        const originalColor = termsText.style.color;
        termsText.style.color = 'red';
        setTimeout(() => { termsText.style.color = originalColor; }, 3000);
      }

      // Разблокируем кнопку, чтобы клиент мог поставить галочку и нажать снова
      this.isSubmitting = false;
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.style.opacity = '1';
        submitButton.innerText = 'Zamawiam'; // Убедись, что тут правильный текст твоей кнопки
      }
      return; // Останавливаем отправку заказа
    }

    // ID транзакции
    const now = new Date();
    const datePart = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    const timePart = `${String(now.getHours()).padStart(2, '0')}-${String(now.getMinutes()).padStart(2, '0')}-${String(now.getSeconds()).padStart(2, '0')}`;
    const transactionId = `${datePart}_${timePart}`;

    // Собираем данные формы
    const formData = {
      name: form.querySelector('#name').value,
      phone: form.querySelector('#phone').value,
      email: form.querySelector('#email').value,
      message: form.querySelector('#message') ? form.querySelector('#message').value : '',
      payment_method: form.querySelector('input[name="payment_method"]:checked').value,
      delivery_method: form.querySelector('input[name="delivery_method"]:checked').value,
      transactionId: transactionId
    };

    try {
      // 1. Формируем текст сообщения для Telegram
      const orderData = this.formatOrder(cartItems, formData);

      // 2. Отправляем на сервер
      const response = await fetch('/api/submit-order', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message: orderData.message,
          formData: formData,
          cartItems: cartItems
        })
      });

      // Обработка спам-лимита
      if (response.status === 429) {
        const errorData = await response.json();
        alert(errorData.error);
        this.isSubmitting = false;
        if (submitButton) { submitButton.disabled = false; submitButton.style.opacity = '1'; submitButton.innerText = 'Zamawiam'; }
        return;
      }

      if (!response.ok) {
        throw new Error('Błąd serwera');
      }

      const data = await response.json();
      console.log('Odpowiedź serwera:', data);

      // --- АНАЛИТИКА ---
      if (typeof AnalyticsModule !== 'undefined') {
        AnalyticsModule.sendPurchaseData(
          transactionId,
          orderData.totalSum,
          cartItems,
          { email: formData.email, phone: formData.phone, name: formData.name }
        );
      }

      // --- СОХРАНЯЕМ ЧЕК ДЛЯ СТРАНИЦЫ УСПЕХА ---
      if (!data.paymentUrl) {
        const successData = {
          id: formData.transactionId,
          items: cartItems,
          total: orderData.totalSum,
          payment: formData.payment_method,
          delivery: formData.delivery_method,
          name: formData.name,
          phone: formData.phone,
          email: formData.email,
          message: formData.message
        };
        sessionStorage.setItem('lastOrder', JSON.stringify(successData));
      }

      // Очищаем корзину
      localStorage.removeItem('cart');
      if (typeof CartModule !== 'undefined') {
        CartModule.updateCartCounter();
      }

      // --- ФИНАЛЬНЫЙ РЕДИРЕКТ КЛИЕНТА (Моноязычный) ---
      if (data.success) {
        if (data.paymentUrl) {
          window.location.href = data.paymentUrl;
        } else {
          window.location.href = `/success`; // Чистая ссылка без /uk/
        }
      }

    } catch (error) {
      console.error('Błąd:', error);
      alert('Wystąpił błąd podczas wysyłania zamówienia. Spróbuj ponownie później.'); // Польский
      this.isSubmitting = false;
      if (submitButton) { submitButton.disabled = false; submitButton.style.opacity = '1'; submitButton.innerText = 'Zamawiam'; }
    }
  },

  formatOrder(cartItems, formData) {
    let message = '🛍️ Sklep VestAgro.pl\nDziękujemy za zamówienie!\n\n';

    message += `🆔 ID: ${formData.transactionId}\n`;
    message += `👤 Kupujący: ${formData.name}\n`;
    message += `📱 Telefon: ${formData.phone}\n`;
    message += `📧 Email: ${formData.email}\n`;

    let paymentMethodText = 'Nie podano';
    // 1. Оплата частями (30% онлайн, остаток при получении)
    if (formData.payment_method === 'cash_pickup') {
      paymentMethodText = 'Zaliczka 30% online + 70% przy odbiorze';
    } 
    // 2. Прямой перевод на IBAN
    else if (formData.payment_method === 'bank_iban') {
      paymentMethodText = 'Przelew na konto (IBAN)';
    } 
    // 3. Полная оплата онлайн через шлюз Przelewy24
    else if (formData.payment_method === 'przelewy24') {
      paymentMethodText = 'Płatność online (Przelewy24 - opłata 100%)';
    }
    message += `💳 Płatność: ${paymentMethodText}\n`;

    let deliveryMethodText = 'Nie podano';
    if (formData.delivery_method === 'post') {
      deliveryMethodText = 'Poczta / Kurier';    
    } else if (formData.delivery_method === 'address') {
      deliveryMethodText = 'Dostawa pod adres';
    } else if (formData.delivery_method === 'courier') {
      deliveryMethodText = 'Dostawa kurierem';
    }
    message += `🚚 Dostawa: ${deliveryMethodText}\n`;

    if (formData.message && formData.message.trim() !== '') {
      message += `💬 Uwagi: ${formData.message.trim()}\n`;
    }

    message += '\n📦 PRODUKTY:\n';

    let totalSum = 0;
    let itemIndex = 1; // Создаем независимый счетчик для товаров

    cartItems.forEach((item) => {
      // ПРОСТАЯ ЛОГИКА: Если это наш атрибут (цвет), выводим его изящно и без цены
      if (item.sku && item.sku.startsWith('attr-')) {
        message += `🎨 ${item.volume}\n`;
      } else {
        // Иначе это обычный товар или платная опция
        message += `\n${itemIndex}. ${item.title.trim()}\n`;

        let cleanVolume = item.volume && typeof item.volume === 'string'
          ? item.volume.replace(/[-\s]+$/, '').trim()
          : '';

        let detailsRow = [];
        if (cleanVolume) detailsRow.push(`🔹 ${cleanVolume}`);
        if (item.sku) detailsRow.push(`🏷️ SKU: ${item.sku}`);

        if (detailsRow.length > 0) {
          message += `${detailsRow.join('  |  ')}\n`;
        }

        message += `— ${item.quantity} szt. x ${item.price} zł\n`;
        itemIndex++; // Увеличиваем номер только для реальных товаров
      }

      totalSum += item.total;
    });

    message += `\n💰 DO ZAPŁATY: ${totalSum} zł`;

    return { message, totalSum };
  }
};
// ------------END------------

// ------------AnalyticsModule - для отправки данных в GTM + Google Analytics------------
const AnalyticsModule = {

  // Отправка события ADD TO CART
  sendAddToCartData(items, totalValue) {
    if (!items || items.length === 0) return;

    // Мапим данные (на всякий случай, для надежности)
    const itemsForGA4 = items.map(item => ({
      item_id: item.item_id || item.sku,      // Берем ID или SKU
      item_name: item.item_name || item.title, // Берем Имя или Title
      price: parseFloat(item.price),
      quantity: parseInt(item.quantity, 10)
    }));

    // Очищаем ecommerce объект перед отправкой (важно для SPA и GTM)
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });

    window.dataLayer.push({
      'event': 'add_to_cart',
      'ecommerce': {
        'currency': 'PLN',
        'value': parseFloat(totalValue),
        'items': itemsForGA4
      }
    });

    console.log('Analytics: AddToCart sent', itemsForGA4);
  },

  // Отправка события PURCHASE
  sendPurchaseData(transactionId, transactionValue, cartItems, userData = {}) {
    if (!transactionId || !cartItems) {
      console.error('Analytics: Ошибка Purchase - нет ID или товаров');
      return;
    }

    const itemsForGA4 = cartItems.map(item => ({
      item_id: item.sku || item.volume,
      item_name: item.title,
      price: parseFloat(item.price),
      quantity: parseInt(item.quantity, 10)
    }));

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });

    // Формируем объект события
    const purchaseEvent = {
      'event': 'purchase',
      'ecommerce': {
        'transaction_id': transactionId,
        'value': parseFloat(transactionValue),
        'currency': 'PLN',
        'items': itemsForGA4
      }
    };

    // --- НОВОЕ: ДОБАВЛЯЕМ user_data ДЛЯ ENHANCED CONVERSIONS ---
    // Если передали userData, добавляем её в событие
    if (userData && (userData.email || userData.phone)) {
      purchaseEvent.user_data = {
        email: userData.email,         // GTM сам захеширует
        phone_number: userData.phone,  // GTM сам захеширует
        // Можно добавить имя, если хочется, но email/phone главнее
        address: {
          first_name: userData.name
        }
      };
    }

    window.dataLayer.push(purchaseEvent);

    console.log('Analytics: Purchase sent with User Data', {
      id: transactionId,
      value: parseFloat(transactionValue),
      user_data: purchaseEvent.user_data
    });
  }
};
// ------------END------------

// ------------ ФИНАЛЬНАЯ ВЕРСИЯ CartAnimationModule (Vanilla JS) ------------
const CartAnimationModule = {
  init() {
    // Используем делегирование событий: вешаем один слушатель на весь body
    document.body.addEventListener('click', (e) => {
      // Ищем, был ли клик по кнопке заказа или по ее дочерним элементам
      const targetBtn = e.target.closest('.products__card-btn--order');
      if (!targetBtn) return;

      e.preventDefault();

      // --- ПРОВЕРКА НА ПУСТУЮ КОРЗИНУ ---
      const quantityElements = document.querySelectorAll('.products__card-number');
      let totalQuantity = 0;

      quantityElements.forEach(el => {
        totalQuantity += parseInt(el.textContent) || 0;
      });

      // Если общее количество равно нулю, ничего не делаем
      if (totalQuantity === 0) return;
      // --- КОНЕЦ ПРОВЕРКИ ---

      const cart = document.querySelector('.header__cart');
      const productBox = targetBtn.closest('.product-page__wrapper');

      if (!cart || !productBox) return;

      const productImg = productBox.querySelector('.product-gallery__main img');
      if (!productImg) return;

      // 1. Создаем клон изображения
      const clone = productImg.cloneNode(true);

      // 2. Получаем точные координаты картинки относительно экрана (viewport)
      const rect = productImg.getBoundingClientRect();

      // 3. Устанавливаем начальные стили клона через Object.assign
      // Мы используем position: fixed, чтобы не возиться с прокруткой страницы (scrollTop)
      Object.assign(clone.style, {
        position: 'fixed',
        top: `${rect.top}px`,
        left: `${rect.left}px`,
        width: `${rect.width}px`,
        height: `${rect.height}px`,
        zIndex: '1000',
        transition: 'all 1.2s cubic-bezier(0.42, 0, 0.58, 1)', // Нативная плавная кривая
        pointerEvents: 'none', // Чтобы клон не "перехватывал" клики мышки
        opacity: '0.9'
      });

      clone.classList.add('product-clone');
      document.body.appendChild(clone);

      // 4. Рассчитываем координаты цели (корзины)
      const cartRect = cart.getBoundingClientRect();
      const targetTop = cartRect.top + 9;
      const targetLeft = cartRect.left + 11;

      // 5. Запускаем анимацию в следующем кадре отрисовки (аналог setTimeout 20мс)
      // requestAnimationFrame обеспечивает идеальную синхронизацию с частотой монитора
      requestAnimationFrame(() => {
        clone.classList.add('is-flying');
        Object.assign(clone.style, {
          top: `${targetTop}px`,
          left: `${targetLeft}px`,
          width: '25px',
          height: '25px',
          opacity: '0.3' // Клон немного тускнеет при подлете
        });
      });

      // 6. Удаляем клон после завершения CSS-перехода
      clone.addEventListener('transitionend', () => {
        clone.remove();
        // Вызываем сброс счетчиков после анимации
        if (typeof CartModule !== 'undefined' && CartModule.resetProductCounters) {
          CartModule.resetProductCounters();
        }
      }, { once: true }); // Слушатель удалится сам после выполнения
    });
  }
};
// ------------ END ------------

// ------------ CopyModule (Копирование реквизитов IBAN) ------------
const CopyModule = {
  init() {
    const copyButtons = document.querySelectorAll('.checkout__copy-btn');

    copyButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault(); // На всякий случай блокируем стандартное поведение

        const targetId = btn.getAttribute('data-copy-target');
        const textElement = document.getElementById(targetId);

        if (textElement) {
          // Берем чистый текст без пробелов по краям
          const textToCopy = textElement.textContent.trim();

          // Современный метод копирования в буфер обмена
          navigator.clipboard.writeText(textToCopy).then(() => {
            // Визуальный отклик: меняем иконку на галочку
            const originalHTML = btn.innerHTML;
            btn.classList.add('success');
            btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';

            // Возвращаем исходную иконку через 2 секунды
            setTimeout(() => {
              btn.classList.remove('success');
              btn.innerHTML = originalHTML;
            }, 2000);
          }).catch(err => {
            console.error('Ошибка копирования: ', err);
            alert('Не вдалося скопіювати текст. Спробуйте вручну.');
          });
        }
      });
    });
  }
};
// ------------ END ------------

// ----------------Cookie Consent Module------------
const CookieConsentModule = {
  init() {
    console.log('Cookie consent module initialized');
    // Устанавливаем cookie onlyec=false для включения баннера для всех
    document.cookie = "onlyec=false; path=/; expires=" + new Date(Date.now() + 86400000).toUTCString();

    // Запускаем проверку на необходимость показа баннера
    this.checkConsent();
  },

  sendConsentTypeToGTM(consentType) {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      'event': 'consentTypeSelected',
      'setReactionType': consentType
    });
  },

  API() {
    return fetch('https://get.geojs.io/v1/ip/geo.json')
      .then((response) => response.json())
      .then((data) => {
        console.log('Geolocation received:', data);
        const euCountries = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'];
        return euCountries.includes(data.country_code);
      })
      .catch((error) => {
        console.error('API Error:', error);
        return false;
      });
  },

  setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + encodeURIComponent(cvalue) + ";" + expires + ";path=/";
  },

  getCookie(name) {
    let matches = document.cookie.match(new RegExp(
      "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  },

  deleteCookie(cname) {
    return new Promise((resolve, reject) => {
      document.cookie = cname + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
      if (document.cookie.indexOf(cname + '=') === -1) {
        resolve('Deleted');
      } else {
        reject('Failed to delete');
      }
    });
  },

  acceptAllCookies() {
    console.log('All cookies accepted');
    this.setCookie('analyticsSwitch', 'true', 365);
    this.setCookie('advertisingSwitch', 'true', 365);
    this.setAllUpdateGoogleParameters();
    this.hideConsentBanner();
  },

  acceptEssentialCookies() {
    console.log('Only essential cookies accepted');
    this.setCookie('analyticsSwitch', 'false', 365);
    this.setCookie('advertisingSwitch', 'false', 365);
    this.setOnlyEssentialGoogleParameters();
    this.hideConsentBanner();
  },

  setAllUpdateGoogleParameters() {
    this.sendConsentTypeToGTM('All');
    this.setCookie("setTypeAccept", "All", 365);
    this.setCookie("acceptBanner", "accepted", 365);
  },

  setOnlyEssentialGoogleParameters() {
    this.sendConsentTypeToGTM('Essential');
    this.setCookie("setTypeAccept", "Essential", 365);
    this.setCookie("acceptBanner", "accepted", 365);
  },

  setCustomizeGoogleParameters() {
    var analyticsSwitch = document.getElementById('analyticsSwitch').checked;
    var advertisingSwitch = document.getElementById('advertisingSwitch').checked;

    this.setCookie('analyticsSwitch', analyticsSwitch.toString(), 365);
    this.setCookie('advertisingSwitch', advertisingSwitch.toString(), 365);

    if (analyticsSwitch && advertisingSwitch) {
      this.sendConsentTypeToGTM('All');
      this.setCookie("setTypeAccept", "All", 365);
    } else if (analyticsSwitch && !advertisingSwitch) {
      this.sendConsentTypeToGTM('Analytics');
      this.setCookie("setTypeAccept", "Analytics", 365);
    } else if (!analyticsSwitch && advertisingSwitch) {
      this.sendConsentTypeToGTM('Advertising');
      this.setCookie("setTypeAccept", "Advertising", 365);
    } else if (!analyticsSwitch && !advertisingSwitch) {
      this.sendConsentTypeToGTM('Essential');
      this.setCookie("setTypeAccept", "Essential", 365);
    }

    this.setCookie("acceptBanner", "accepted", 365);
  },

  // --- ФУНКЦИИ ОТОБРАЖЕНИЯ (ОЧИЩЕННЫЕ ОТ HTML) ---

  customizeCookies() {
    var analyticsSwitchCookie = this.getCookie('analyticsSwitch');
    var advertisingSwitchCookie = this.getCookie('advertisingSwitch');

    var analyticsSwitchChecked = (analyticsSwitchCookie === 'true');
    var advertisingSwitchChecked = (advertisingSwitchCookie === 'true');

    var analyticsCheckbox = document.getElementById('analyticsSwitch');
    var advertisingCheckbox = document.getElementById('advertisingSwitch');

    if (analyticsCheckbox) analyticsCheckbox.checked = analyticsSwitchChecked;
    if (advertisingCheckbox) advertisingCheckbox.checked = advertisingSwitchChecked;

    // Скрываем главный вид, показываем настройки
    document.getElementById('cookieViewMain').style.display = 'none';
    document.getElementById('cookieViewCustomize').style.display = 'block';
  },

  showInitialConsent() {
    // Показываем главный контейнер всего баннера
    var container = document.getElementById('cookieConsentContainer');
    if (container) container.style.display = 'block';

    // Показываем главный вид, скрываем настройки (если вернулись кнопкой Back)
    var viewMain = document.getElementById('cookieViewMain');
    var viewCustomize = document.getElementById('cookieViewCustomize');

    if (viewMain) viewMain.style.display = 'block';
    if (viewCustomize) viewCustomize.style.display = 'none';
  },

  showMiniBannerAfterAcceptedCookies() {
    var miniBanner = document.getElementById('cookieConsentContainerMini');
    if (miniBanner) {
      miniBanner.style.display = 'block';
    }

    window.showInitialConsentBig = function () {
      if (miniBanner) {
        miniBanner.style.display = 'none';
      }
      CookieConsentModule.showInitialConsent();
    };
  },

  hideConsentBanner() {
    var consentBanner = document.getElementById('cookieConsentContainer');
    if (consentBanner) {
      consentBanner.style.display = 'none';
    }
    this.showMiniBannerAfterAcceptedCookies();
  },

  saveAndApply() {
    console.log('Save and apply settings');
    this.setCustomizeGoogleParameters();
    this.hideConsentBanner();
  },

  ifPeopleFromEC() {
    console.log('User from EU - showing banner');
    this.setCookie("setTypeAccept", "UserEC", 365);
    this.setCookie("setWithGeo", "UserEC", 365);
    this.showInitialConsent();
  },

  ifPeopleDontFromEC() {
    console.log('User not from EU - not showing banner');
    this.sendConsentTypeToGTM('UserDontEC');
    this.setCookie("setTypeAccept", "UserDontEC", 365);
    this.setCookie("acceptBanner", "accepted", 365);
    this.setCookie("setWithGeo", "UserDontEC", 365);
  },

  checkConsent() {
    const onlyec = this.getCookie('onlyec');
    const acceptBanner = this.getCookie('acceptBanner');
    console.log(`[Cookie Consent] Статус: onlyec=${onlyec}, acceptBanner=${acceptBanner}`);

    if (acceptBanner === 'accepted') {
      console.log('[Cookie Consent] Согласие уже дано, показываем мини-баннер.');
      this.showMiniBannerAfterAcceptedCookies();
      return;
    }

    if (onlyec === 'false') {
      console.log('[Cookie Consent] Режим "Показывать всем" активен. Показываем баннер.');
      this.showInitialConsent(); // Просто вызываем показ (без document.createElement)
      return;
    }

    console.log('[Cookie Consent] Режим "Только для ЕС". Запускаем API геолокации...');
    this.API().then((isEC) => {
      const currentAcceptBanner = this.getCookie('acceptBanner');
      if (currentAcceptBanner === 'accepted') {
        this.showMiniBannerAfterAcceptedCookies();
        return;
      }

      const setTypeAccept = this.getCookie('setTypeAccept');
      if ((setTypeAccept === "UserDontEC") && isEC) {
        this.deleteCookie("setTypeAccept")
          .then(() => this.deleteCookie("acceptBanner"))
          .then(() => {
            console.log('[Cookie Consent] Cookies удалены для перехода от неЕС в ЕС');
            this.ifPeopleFromEC();
          })
          .catch((error) => {
            this.ifPeopleFromEC();
          });
        return;
      }

      if (isEC) {
        this.ifPeopleFromEC();
      } else {
        this.ifPeopleDontFromEC();
      }
    }).catch(apiError => {
      console.error('[Cookie Consent] Ошибка API геолокации:', apiError);
      const currentAcceptBanner = this.getCookie('acceptBanner');
      if (currentAcceptBanner === 'accepted') {
        this.showMiniBannerAfterAcceptedCookies();
      } else {
        this.ifPeopleFromEC();
      }
    });
  }
};

window.CookieConsentModule = CookieConsentModule;
// ----------------Cookie Consent Module END------------


// ------------Функция инициализации всех модулей------------
function initializeApp() {

  // ActiveMenuModule.init(); 
  BurgerMenuModule.init();
  SliderModule.init();
  ProductModule.init();
  FormModule.init();
  PhoneModule.init();
  CartAnimationModule.init();
  CartModule.init();
  CopyModule.init();
  CookieConsentModule.init();
}

// Запускаем всю цепочку, когда DOM полностью готов
document.addEventListener('DOMContentLoaded', initializeApp);